//checkApp 为全局的 app 对象，checkApp.core 包括了核心 api 
const { Feature, meta, hook } = checkApp.core;//eslint-disable-line
const { utils } = checkApp.common;//eslint-disable-line

const PRICE_CACHE = {};

//通过继承 Featrue 实现一个扩展
//meta 用于描述插件的名称、依赖及权重
@meta('cnService', ['request', 'suffixsService'], 99999)
export default class CNServiceFeature extends Feature {

  @hook('service.checkApi')
  getCheckApi() {
    return '//checkapi.aliyun.com/check/checkdomain';
  }

  convertCheckItem = async (item) => {
    if (!item) return;
    const productInfo = this.suffixsService.getDetailList();
    item.domain = item.domain || item.name;
    item.suffix = item.suffix || utils.getSuffix(item.domain);
    item.productId = (productInfo[item.suffix] || {}).product_id;
    try {
      item.priceList = await this.getPriceList(item.productId);
    } catch (err) {
      console.error('Query price error:', err); //eslint-disable-line
    }
    //console.log('item.priceList', item.priceList);
    item.prices = item.prices || {};
    item.prices.activate = item.prices.activate || {};
    item.prices.renew = item.prices.renew || {};
    //新购
    item.prices.activate.tradePrice = (item.priceList
      .find(item => item.period == 12 && item.action != 'renew') || {}).money;
    item.prices.activate.originalPrice = item.prices.activate.tradePrice;
    //续费
    item.prices.renew.tradePrice = (item.priceList
      .find(item => item.period == 12 && item.action == 'renew') || {}).money;
    item.prices.renew.originalPrice = item.prices.renew.tradePrice;
    return item;
  }

  @hook('service.convertCheckItem')
  retConvertCheckItem() {
    return this.convertCheckItem;
  }

  getPriceList = async (productId) => {
    //console.log('productId', productId);
    const periodList = [12, 36, 60, 120];
    const data = [];
    periodList.forEach(period => {
      data.push(
        { productID: productId, period: period },
        { productID: productId, period: period, action: 'renew' }
      );
    });
    if (!PRICE_CACHE[productId]) {
      PRICE_CACHE[productId] = this.request.send(
        '//netcn.console.aliyun.com/core/product/infostatic',
        { data: JSON.stringify(data) }, { loading: false, ignoreError: true });
    }
    return PRICE_CACHE[productId];
  }

  @hook('service.getPriceList')
  retGetPriceList() {
    return this.getPriceList;
  }

}


// WEBPACK FOOTER //
// ./src/service/index.js